import * as React from 'react';
const CustomDnbMoneyBag = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.71 38.96" {...props}>
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <path
          fill="none"
          stroke="#a5e1d2"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19 15.68H8.87c-4.1 3-8.37 8-8.37 12.71 0 6.53 3.38 10.07 13.36 10.07 10.15 0 13.35-3.54 13.35-10.07 0-4.76-4.27-9.71-8.21-12.71M22.23.5 6.91 3A5.81 5.81 0 0 1 9.4 8.09h8.38c0-3.71 4.45-7.59 4.45-7.59"
        />
        <path
          d="M12.43 32.1h2.67l-3.2-4.24 3-3.35h-2.65l-2.31 2.82v-5.82H7.8V32.1h2.32V30l.53-.53zm8.02-7.77a2.79 2.79 0 0 0-2.32 1.24v-1.24h-2v7.59h2.32v-4.06a1.73 1.73 0 0 1 2-1.76h.89v-1.94a1.7 1.7 0 0 1-.89.17"
          className="custom_dnb_money_bag_svg__cls-2"
        />
      </g>
    </g>
  </svg>
);
export default CustomDnbMoneyBag;
